var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","gap":"8px"}},[_c('span',{staticClass:"deco_circle",style:({ marginTop: _vm.marginTop })}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }